import * as types from '../constants/action-types';
export const initialState = {
    workflow: {
        patientSurveyId: null,
        providerSurveyId: null,
        isDokbotExtensionInstalled: false,
        patientSurveyFrequency: null,
        providerSurveyFrequency: null,
    },
};
export const reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case types.SET_SURVEY_WORKFLOW:
            return {
                ...state,
                workflow: {
                    ...payload,
                },
            };
        default:
            return state;
    }
};
export default reducer;
